var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-app-bar',{staticClass:"white elevation-1",attrs:{"dense":"","fixed":"","app":""}},[_c('img',{attrs:{"src":require("../assets/logorinconpng5.png"),"height":"30","alt":""}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }